import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Store.css';
import Confirmation from '../Confirmation/Confirmation';
import { TITLE_ID } from '../../Constants';
import { gaEvents } from '../../util/events';

function Store({ activeTab, walletAddress, userData }) {
  // ACTIVE TAB IS so we refresh when we switch back to this tab!
  const [nfts, setNfts] = useState([]);
  const [activeNft, setActiveNft] = useState([]);
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'LookupPlayerProfile',
          FunctionParameter: {
            IncludeRoleAndLoadout: true,
            IncludeTopGear: true,
            IncludeBasicStatistics: true,
            IncludeAssets: true,
          },

        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        const items = response.data.data.FunctionResult.result.assets.inventoryItems;
        // setShowModal(false);
        const nftItems = [];

        items.forEach((item) => {
          if (item.data.ImageUrl && item.data.Title !== 'Aqua Shield') {
            nftItems.push(item);
          }
        });
        gaEvents.loadTransferNfts(nftItems.length);
        setNfts(nftItems);
        // onLoginSuccess();
      });
  }, []);

  useEffect(() => {
    if (activeTab === '1') {
      axios
        .post(
          `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
          {
            FunctionName: 'LookupPlayerProfile',
            FunctionParameter: {
              IncludeRoleAndLoadout: true,
              IncludeTopGear: true,
              IncludeBasicStatistics: true,
              IncludeAssets: true,
            },

          },
          {
            headers: {
              'X-EntityToken': window.sessionStorage.getItem('entity_token'),
            },
          },
        ).then((response) => {
          const items = response.data.data.FunctionResult.result.assets.inventoryItems;
          // setShowModal(false);
          const nftItems = [];
          items.forEach((item) => {
            if (item.data.ImageUrl && item.data.Title !== 'Aqua Shield') {
              nftItems.push(item);
            }
          });
          setNfts(nftItems);
          // onLoginSuccess();
        });
    }
  }, [activeTab]);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  async function refresh() {
    await delay(2000);
    // console.log('Waited 2s');
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'LookupPlayerProfile',
          FunctionParameter: {
            IncludeRoleAndLoadout: true,
            IncludeTopGear: true,
            IncludeBasicStatistics: true,
            IncludeAssets: true,
          },

        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        const items = response.data.data.FunctionResult.result.assets.inventoryItems;
        // setShowModal(false);
        const nftItems = [];
        items.forEach((item) => {
          if (item.data.ImageUrl && item.data.Title !== 'Aqua Shield') {
            nftItems.push(item);
          }
        });

        setNfts(nftItems);
      // onLoginSuccess();
      });
  }

  function loadNft(nft) {
    setIsConfirming(true);
    setActiveNft(nft);
  }

  function onCloseModal() {
    setIsConfirming(false);
  }

  return (
    <div>
      <Confirmation
        walletAddress={walletAddress}
        isShowLogin={isConfirming}
        onCloseModal={onCloseModal}
        refresh={refresh}
        nft={activeNft}
      />
      {nfts.length === 0
        && <h1 className="second-header no-nft-message">No NFTs Available</h1>}

      {nfts.length > 0
      && (
      <div className="nft-market">
        {nfts && nfts.map((nft, index) => (
          <div
            className="nft border  rounded-xl overflow-hidden"
            onClick={() => { loadNft(nft); }}
            key={index}
          >
            <div className="nft-content">
              <div className="nft-img-container">
                <img className="nft-img" src={nft.data.ImageUrl} />
              </div>
              <p className="nft-name">{nft ? nft.data.Title : 'empty'}</p>
              <p className="mint-text nft-id">{nft ? nft.instanceId : ''}</p>
              <p className="mint-text">Ready to transfer!</p>
            </div>
          </div>
        ))}
        {Array(3)
          .fill(undefined)
          .map((nft, i) => (
            <div
              key={i}
              className="empty nft border  rounded-xl overflow-hidden"
            >
              <div className="nft-label ">
                <p>'test'</p>
              </div>
              <div className="nft-name">
                <p>test</p>
              </div>
              <div className="img-container">
                <img
                  className="nft-img"
                  src="logo_trasparent.png"
                />
              </div>

              <div className="nft-price">
                <p>RUN</p>
              </div>
            </div>
          ))}
      </div>
      )}
    </div>
  );
}

export default Store;
